<script>
  import {getContext, onMount} from 'svelte';
  import lang from './BuySuccessPopup.lang';
  import {PATHS} from '@/const';
  import {mc} from '@/core';
  import {numUtil, coinUtil} from '@/helper';
  import {fixLink$} from '@/store';
  import {Button, Modal} from '@/widgets';
  import {PAY_ERROR} from '@/modules/premium/const';
  import errors from '@/modules/error/error.lang';

  const LG = getContext('LG');
  const premiumMap = {
    purchasePlan30V1: LG(lang.day30),
    purchasePlan90V1: LG(lang.day90),
    purchasePlan365V1: LG(lang.day365),
  };

  let visible = false;
  let title;
  let isSuccess;
  let membershipType;
  let price;
  let scrollWidth = 1080;
  let code;
  let data;
  let message;

  $: width = scrollWidth > 640 ? 'width:360px;' : '';

  onMount(() =>
    mc.subscribe('buy-success', 'dialog-show', ({record}) => {
      isSuccess = record.type;
      membershipType = record.membershipType;
      price = record.price;
      code = record.code;
      data = record.data;
      message = record.message;
      title = isSuccess === 'success' ? LG(lang.OrderSuccess) : LG(lang.OrderFaild);
      visible = true;
    })
  );

  function handleBuy() {
    const record = {
      membershipType,
      price,
    };
    visible = false;
    mc.send('buy-premium', 'dialog-show', {record});
  }

  function handleGoToAccount() {
    visible = false;
    window.location.assign($fixLink$(PATHS.ACCOUNT_OVERVIEW.pathname));
  }
</script>

<style>
  .footer {
    margin: 40px auto 0;
  }
  .icon {
    width: 72px;
  }
  .icon img {
    width: 100%;
  }
  .mt42 {
    margin-top: 42px;
  }
  .wp80 {
    width: 80%;
  }
  .w18 {
    width: 18px;
    height: 18px;
  }
</style>

<svelte:window bind:innerWidth={scrollWidth} />
{#if visible}
  <Modal style={width}>
    <div class="lh24 b f16 T2 df jcsb" slot="header">
      <div class="lh24 fw2 f18 T1">{title}</div>
      <i class="iconfont lh12 f12 T4 cp" on:click={() => (visible = false)}>&#xe614;</i>
    </div>
    <div class="footer df fdc" slot="footer">
      {#if isSuccess === 'success'}
        <div>
          <div class="df fdc aic">
            <div class="df jcsb T2 lh22 wp80 wsn">
              <label class="f14">{LG(lang.AmountSpent)}</label>
              <span class="fw2">{numUtil.floor(data.amountEv, 8, 8)} {data.currency}</span>
            </div>
            <div class="df jcsb T2 lh22 mt12 wp80 wsn">
              <label class="f14">{LG(lang.PaymentCoin)}</label>
              <span class="fw2 df aic">
                <img class="w18 " src={coinUtil.getUrl(data.currency)} alt="Coin" />
                <span class="ml4">{data.currency}</span>
              </span>
            </div>
            <div class="df jcsb T2 lh22 mt12 wp80 wsn">
              <label class="f14">{LG(lang.Product)}</label>
              <span class="fw2">{premiumMap[membershipType]}</span>
            </div>
          </div>
          <div class="df jcsb mt42">
            <Button type="primary" minWidth="100%" on:click={handleGoToAccount}>{LG(lang.CheckPremium)}</Button>
          </div>
        </div>
      {:else}
        <div>
          <div class="df fdc aic">
            <div class="icon">
              <img src={PAY_ERROR} alt="Error" />
            </div>
            <div class="f14 lh18 T2 mt8 tc">
              {@html errors[code] ? LG(errors[code]) : message}
            </div>
          </div>
          <div class="df jcsb mt42">
            <Button type="primary" on:click={handleBuy}>{LG(lang.TryAgain)}</Button>
            <Button type="default" on:click={() => (visible = false)}>{LG(lang.Cancel)}</Button>
          </div>
        </div>
      {/if}
    </div>
  </Modal>
{/if}
